<template>
  <div v-if="visible">
    <van-popup
      v-model="visible"
      position="top"
      :close-on-click-overlay="false"
      :style="{
        height: '100%',
        width: '100%',
        overflow: 'hidden',
      }"
    >
    <!-- {{ obj }} -->
      <van-sticky offset-top="0">
        <div class="title" @click="close">
          <i class="el-icon-back C2" />
          {{ obj.DispName }}
          <!-- {{ gCheckS1Data(obj) }} -->
        </div>
      </van-sticky>

      <div class="main">
        <!-- {{ groups }} -->
        <van-image
          :src="obj.ImgFile"
          lazy-load
          width="200"
          @click="preview = true"
          :show-error="false"
        />

        <!-- <div class="remark" v-html="gGetIcon(obj.Remark)" /> -->
        <ItemGroups :groups="obj.Groups" @click="showDetailGroup" />
        <div style="height: 10rem" />
      </div>

      <van-image-preview
        v-model="preview"
        :images="[obj.ImgFile]"
        :showIndex="false"
      />
      <FrmItemDetailGroup ref="rItemDetailGroup" />

      <Footer :b1="getBtnText()" :anime="anime" @b1c="onOk" />
    </van-popup>
  </div>
</template>

<style scoped>
.title {
  background-color: rgba(255, 255, 255, 0.95);
  font-size: 1.6rem;
  padding: 1rem;
  z-index: 3;
}
.main {
  padding: 1rem;
  padding-top: 0rem;
  overflow: scroll;
  height: 100%;
}
</style>

<script>
export default {
  data() {
    return {
      visible: false,
      obj: null,
      preview: false,
      anime: false,
    };
  },
  methods: {
    getBtnText() {
      if (!this.gCheckS1Data(this.obj)) {
        this.anime = false;
        return "請選擇附餐 Side Check";
      }

      this.anime = true;
      return "確認 Confirm";
    },
    showDetailGroup(obj) {
      if (obj.Groups == undefined) {
        return;
      }
      if (obj.Groups.length == 0) {
        return;
      }
      this.$refs.rItemDetailGroup.show(obj);
    },
    show(obj) {
      this.obj = obj;
      this.visible = true;
    },
    close() {
      this.obj.Qty = 0;
      this.clearForm();
      this.obj = null;
      this.visible = false;
    },
    clearForm() {
      this.obj.Groups.map((lv) => {
        lv.options.map((r) => {
          r.Qty = 0;
        });
      });
    },
    onOk() {
      if (!this.gCheckS1Data(this.obj)) {
        return this.gMsgbox("請確認附餐必選項目", "Side Check");
      }
      this.visible = false;
    },
  },
};
</script>
